import { css } from '@emotion/css';

// This will be removed when integrating standard empty states.
export const emptyDescription = (isMobile: boolean) => css`
  max-width: ${isMobile ? 27.2 : 22.4}rem;
`;

// We are inserting HTML message directly into the dom. That's why we
// are adding the styles in the bold tag.
export const messageItem = css`
  b {
    color: var(--text-primary);
    font-weight: var(--fw-label-02);
    font-family: var(--ff-label-02);
    font-size: var(--fs-label-02);
    line-height: var(--lh-label-02);
    letter-spacing: var(--ls-label-02);
  }
`;

export const messageItemMobile = css`
  b {
    color: var(--text-primary);
    font-weight: var(--fw-label-01);
    font-family: var(--ff-label-01);
    font-size: var(--fs-label-01);
    line-height: var(--lh-label-01);
    letter-spacing: var(--ls-label-01);
  }
`;
